import ContractPreviewModal from "@panel/shared/contract/components/contract-preview-modal";
import ContractReviewModal from "@panel/shared/contract/components/contract-review-modal";
import PublisherStatusCard from "./components/publisher-status-card";
import PublisherContractsTable from "./components/publisher-contracts-table";
import useBrandContractPage from "./hooks/use-brand-contract-page";
import { PAGE_NOTE } from "./misc/constants";

const BrandPublisherContract = () => {
    const { brandName, counts, reviewModal, previewModal, publisherTable } = useBrandContractPage();

    return (
        <div className="p-6">
            <h1 className="text-2xl font-semibold tracking-tight">Contracts</h1>
            <p className="mt-1 max-w-3xl text-sm text-muted">{PAGE_NOTE}</p>

            <div className="mt-6">
                <PublisherStatusCard counts={counts} brandName={brandName} />
            </div>

            <div className="mt-4">
                <PublisherContractsTable {...publisherTable} />
            </div>

            <ContractReviewModal {...reviewModal} />

            <ContractPreviewModal {...previewModal} />
        </div>
    );
};

export default BrandPublisherContract;
